/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Play_Pause_TitleInputs */



/**
* | output |
* | --- |
* | "Play/Pause" |
*
* @param {Player_Play_Pause_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_play_pause_title = /** @type {((inputs?: Player_Play_Pause_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Play_Pause_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lecture/Pause")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiedergabe/Pause")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riproduci/Pausa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Воспроизведение/Пауза")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reproducir/Pausa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("播放/暂停")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再生/一時停止")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चलाएँ/रोकें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reproduzir/Pausar")
	return /** @type {LocalizedString} */ ("Play/Pause")
});